import { store } from '@/decorators/store';
import { CallType } from '@/entities/CallType';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'CallType' })
export class CallTypeStore extends AbstractEntityStore<CallType> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
